import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Layout as MarketingLayout } from 'src/layouts/marketing';
import HomePage from 'src/pages';
import AboutPage from 'src/pages/about';
import TeamMemberPage from 'src/pages/about/team/[slug]';
import ProjectsPage from 'src/pages/projects';
import CaseStudiesPage from 'src/pages/projects/case-studies';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
import ContactPage from 'src/pages/contact';
import CheckoutPage from 'src/pages/checkout';
import RefundPolicyPage from 'src/pages/refund-policy';
import PrivacyPolicyPage from 'src/pages/privacy-policy';
import EulaPage from 'src/pages/eula';
import SupportPage from 'src/pages/support';
import SchedulePage from 'src/pages/schedule';
import SaasPage from 'src/pages/saas';
import BlogIndexPage from 'src/pages/blog/index';
import BlogPostPage from 'src/pages/blog/[slug]';
import BrandingPage from 'src/pages/services/branding';
import WebsitesPage from 'src/pages/services/websites';
import MarketingPage from 'src/pages/services/marketing';
import GoogleBusinessProfilePage from 'src/pages/services/google-business-profile-optimization';
import AdBuyingPage from 'src/pages/services/ad-buying';
import ContentPage from 'src/pages/services/content';
import AiAutomationPage from 'src/pages/services/ai-automation';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { componentsRoutes } from './components';
import { dashboardRoutes } from './dashboard';
import GoogleCallbackPage from 'src/pages/auth/google/callback';

export const routes: RouteObject[] = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'about',
        element: <AboutPage />
      },
      {
        path: 'about/team/:slug',
        element: <TeamMemberPage />
      },
      {
        path: 'projects',
        element: <ProjectsPage />
      },
      {
        path: 'projects/case-studies',
        element: <CaseStudiesPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
      {
        path: 'schedule',
        element: <SchedulePage />
      },
      {
        path: 'support',
        element: <SupportPage />
      },
      {
        path: 'blog',
        element: <BlogIndexPage />
      },
      {
        path: 'blog/page/:page',
        element: <BlogIndexPage />
      },
      {
        path: 'blog/:slug',
        element: <BlogPostPage />
      },
      {
        path: 'services/branding',
        element: <BrandingPage />
      },
      {
        path: 'services/websites',
        element: <WebsitesPage />
      },
      {
        path: 'services/marketing',
        element: <MarketingPage />
      },
      {
        path: 'services/google-business-profile-optimization',
        element: <GoogleBusinessProfilePage />
      },
      {
        path: 'services/ad-buying',
        element: <AdBuyingPage />
      },
      {
        path: 'services/content',
        element: <ContentPage />
      },
      {
        path: 'services/ai-automation',
        element: <AiAutomationPage />
      },
      {
        path: 'refund-policy',
        element: <RefundPolicyPage />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />
      },
      {
        path: 'eula',
        element: <EulaPage />
      },
      {
        path: 'saas',
        element: <SaasPage />
      },
      ...componentsRoutes,
      {
        path: '*',
        element: <Error404Page />
      }
    ]
  },
  ...authRoutes,
  ...authDemoRoutes,
  ...dashboardRoutes,
  {
    path: 'auth/google/callback',
    element: <GoogleCallbackPage />
  },
  {
    path: 'checkout',
    element: <CheckoutPage />
  },
  {
    path: '401',
    element: <Error401Page />
  },
  {
    path: '404',
    element: <Error404Page />
  },
  {
    path: '500',
    element: <Error500Page />
  }
];
